"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalance = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var OverdueAccountBalance_1 = tslib_1.__importDefault(require("./OverdueAccountBalance"));
var PayOnTimeDiscountAccountBalance_1 = tslib_1.__importDefault(require("./PayOnTimeDiscountAccountBalance"));
var CreditAccountBalance_1 = tslib_1.__importDefault(require("./CreditAccountBalance"));
var ZeroAccountBalance_1 = tslib_1.__importDefault(require("./ZeroAccountBalance"));
var BalanceDueAccountBalance_1 = tslib_1.__importDefault(require("./BalanceDueAccountBalance"));
var SmoothPay_1 = tslib_1.__importDefault(require("./SmoothPay"));
var DirectDebit_1 = tslib_1.__importDefault(require("./DirectDebit"));
var ArrearsOnHold_1 = tslib_1.__importDefault(require("./ArrearsOnHold"));
var AccountBalance_gql_1 = require("./AccountBalance.gql");
var client_1 = require("@apollo/client");
var AccountBalance_types_1 = require("./AccountBalance.types");
var _1 = require(".");
var PreviousInvoiceOverdueBalance_1 = tslib_1.__importDefault(require("./PreviousInvoiceOverdueBalance"));
var AccountBalanceData = function (_a) {
    var accountBalance = _a.accountBalance, directDebitSetupLinkOnClick = _a.directDebitSetupLinkOnClick, viewPlan = _a.viewPlan, directDebitEditLinkOnClick = _a.directDebitEditLinkOnClick, paymentExtensionAlert = _a.paymentExtensionAlert;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var hasDirectDebitSetup = accountBalance.paymentMethod === AccountBalance_types_1.PaymentMethod.DIRECTDEBIT;
    var hasSmoothPaySetup = accountBalance.hasSmoothPay;
    var hasPaymentExtensionSetup = accountBalance.hasPaymentExtension;
    var accountBalanceType = accountBalance.hasDiscount
        ? AccountBalance_types_1.AccountBalanceType.PAYONTIMEDISCOUNT
        : accountBalance.isOverdue
            ? AccountBalance_types_1.AccountBalanceType.OVERDUE
            : accountBalance.hasCredit
                ? AccountBalance_types_1.AccountBalanceType.CREDIT
                : accountBalance.totalBalance.toString() === '0'
                    ? AccountBalance_types_1.AccountBalanceType.ZERO
                    : AccountBalance_types_1.AccountBalanceType.BALANCEDUE;
    var hasPreviousInvoiceOverdue = accountBalance.isOverdue && accountBalance.hasDiscount;
    var accountBalanceTypeProps = {
        totalBalance: accountBalance.totalBalance,
        dueDate: accountBalance.dueDate,
        hasDirectDebit: hasDirectDebitSetup,
        hasSmoothPay: hasSmoothPaySetup,
        hasPaymentExtension: hasPaymentExtensionSetup,
        potBalance: accountBalance.potBalance,
    };
    var getAccountBalance = function (balanceType, accBalProps, accBal) {
        switch (balanceType) {
            case AccountBalance_types_1.AccountBalanceType.OVERDUE:
                return react_1.default.createElement(OverdueAccountBalance_1.default, tslib_1.__assign({}, accBalProps, { overdueAmt: accBal.overdueAmt }));
            case AccountBalance_types_1.AccountBalanceType.PAYONTIMEDISCOUNT:
                return react_1.default.createElement(PayOnTimeDiscountAccountBalance_1.default, tslib_1.__assign({}, accBalProps, { discountAmt: accBal.discountAmt }));
            case AccountBalance_types_1.AccountBalanceType.CREDIT:
                return react_1.default.createElement(CreditAccountBalance_1.default, { totalBalance: accBal.totalBalance });
            case AccountBalance_types_1.AccountBalanceType.ZERO:
                return react_1.default.createElement(ZeroAccountBalance_1.default, { totalBalance: accBal.totalBalance });
            default:
                return react_1.default.createElement(BalanceDueAccountBalance_1.default, tslib_1.__assign({}, accBalProps));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        viewPlan && (react_1.default.createElement(asg_1.Box, { margin: { bottom: '12px' }, width: "fit-content" }, viewPlan)),
        accountBalance.hasArrearsOnHold && (react_1.default.createElement(ArrearsOnHold_1.default, { aohTotal: accountBalance.arrearsOnHoldTotal, reviewDate: accountBalance.arrearsOnHoldReviewDate })),
        hasPreviousInvoiceOverdue && react_1.default.createElement(PreviousInvoiceOverdueBalance_1.default, { overdueAmt: accountBalance.overdueAmt }),
        react_1.default.createElement(asg_1.Box, { border: { size: '2px', color: asg_1.colors.brandOrange }, round: "8px", margin: {
                top: responsiveSize === 'xs' ? '5px' : undefined,
                bottom: hasDirectDebitSetup ? 'xsmall' : 'xsmall',
            }, width: "100%", background: asg_1.colors.white, pad: {
                vertical: 'small',
                horizontal: responsiveSize === 'xs' ? 'medium' : 'small',
            }, "data-testid": "accountBalanceContainer" }, getAccountBalance(accountBalanceType, accountBalanceTypeProps, accountBalance)),
        hasSmoothPaySetup && (react_1.default.createElement(SmoothPay_1.default, { smoothPayAmt: accountBalance.smoothPayAmt, smoothPayDate: accountBalance.smoothPayDate })),
        react_1.default.createElement(DirectDebit_1.default, { hasDirectDebitSetup: hasDirectDebitSetup, directDebitSetupLinkOnClick: directDebitSetupLinkOnClick, directDebitEditLinkOnClick: directDebitEditLinkOnClick, paymentExtensionAlert: paymentExtensionAlert })));
};
var AccountBalance = function (props) {
    var customerNumber = props.customerNumber, accountNumber = props.accountNumber, handlePaymentBtnLoadingState = props.handlePaymentBtnLoadingState, updatePaymentDetails = props.updatePaymentDetails, viewPlan = props.viewPlan, directDebitSetupLinkOnClick = props.directDebitSetupLinkOnClick, directDebitEditLinkOnClick = props.directDebitEditLinkOnClick, paymentExtensionAlert = props.paymentExtensionAlert;
    var _a = (0, react_1.useState)(null), accountBalanceDetails = _a[0], setAccountBalanceDetails = _a[1];
    var _b = (0, react_1.useState)(true), accBalLoading = _b[0], setAccBalLoading = _b[1];
    var getAccountBalance = (0, client_1.useLazyQuery)(AccountBalance_gql_1.ACCOUNT_BALANCE_QUERY, {
        onCompleted: function (response) {
            var accountBalanceData = response.accountBalance;
            setAccountBalanceDetails(accountBalanceData);
            updatePaymentDetails(accountBalanceData.totalBalance, accountBalanceData.hasCredit);
            setAccBalLoading(false);
            //Set the loading state for make a payment btn
            handlePaymentBtnLoadingState(false);
        },
        onError: function (error) {
            //Set the loading state for account balance and make a payment btn
            setAccBalLoading(false);
            handlePaymentBtnLoadingState(false);
            // eslint-disable-next-line no-console
            console.log(error);
        },
        fetchPolicy: 'cache-and-network',
    })[0];
    (0, react_1.useEffect)(function () {
        if (accountNumber !== '0' && accountNumber !== '') {
            setAccBalLoading(true);
            handlePaymentBtnLoadingState(true);
            getAccountBalance({
                variables: {
                    customerId: customerNumber,
                    accountNumber: accountNumber,
                },
            });
        }
    }, [customerNumber, accountNumber, getAccountBalance, handlePaymentBtnLoadingState]);
    if (!accBalLoading && accountBalanceDetails)
        return (react_1.default.createElement(AccountBalanceData, { viewPlan: viewPlan, accountBalance: accountBalanceDetails, directDebitSetupLinkOnClick: directDebitSetupLinkOnClick, directDebitEditLinkOnClick: directDebitEditLinkOnClick, paymentExtensionAlert: paymentExtensionAlert }));
    if (!accBalLoading && accountBalanceDetails === null)
        return react_1.default.createElement(_1.AccountBalanceErrorState, null);
    return react_1.default.createElement(_1.AccountBalanceLoadingState, null);
};
exports.AccountBalance = AccountBalance;
//# sourceMappingURL=AccountBalance.js.map